import * as clips from './clips/*.grufclip';
// This will export all clips in the /presets folder as an array
export const factoryClips = Object.entries(clips).map(([name, clip]) => ({...clip, _metadata: { ...clip._metadata, name, isFactory: true }}));